import {
  getApplicationsBaseInfo,
  GetApplicationsBaseInfoArgs
} from './get-applications-base-info'
import { useContrastQuery } from '../../../hooks/use-contrast-query'
import { ApplicationBaseInfo } from '../index'
import { Query } from '../../../hooks/queries'

export const useGetApplicationsBaseInfo = ({
  organizationUuid
}: GetApplicationsBaseInfoArgs) => {
  const {
    data: applications,
    error,
    isError,
    isLoading
  } = useContrastQuery<GetApplicationsBaseInfoArgs, ApplicationBaseInfo[]>(
    [Query.APPLICATION_BASE_INFO, organizationUuid],
    getApplicationsBaseInfo,
    {
      organizationUuid
    }
  )

  return {
    applications,
    error,
    isError,
    isLoading
  }
}
